import { useIntl } from 'react-intl';
import Widget from '../../../components/Widget';
import './style.scss';

const PrivacyPolicy = () => {
  const intl = useIntl();

  return (
    <div className="">
      <Widget
        breadcrumbs={[intl.formatMessage({ id: 'adminMenu.privacyPolicy' })]}
        tabProps={{
          onChange: (key: string) => {},
        }}
        content={
          <div className="privacy-policy">
            <div
              dangerouslySetInnerHTML={{
                __html: `
                  <div class="privacy-policy-main">
                    ${Array.from({ length: 8 })
                      .map(
                        (_, index) => `
                      <div class="privacy-policy-main-one">
                        <div class="privacy-policy-main-one-title">${intl.formatMessage({ id: `privacyPolicy.updated.title${index + 1}` })}</div>
                        <div class="privacy-policy-main-one-content">${intl.formatMessage({ id: `privacyPolicy.updated.content${index + 1}` })}</div>
                      </div>
                    `,
                      )
                      .join('')}
                  </div>
                `,
              }}
            />
          </div>
        }
        title={intl.formatMessage({ id: 'adminMenu.privacyPolicy' })}
      />
    </div>
  );
};

export default PrivacyPolicy;
